import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q74ps4ybre: FaireBrandEntity = {
  token: "b_q74ps4ybre",
  type: "brand",
  name: "NOVA BRANDS",
  avatarUrl:
    "https://cdn.faire.com/fastly/8745e9f37219741d288cb6d4a4c98c9785440124f05cf616432a3705c03526e7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c5479b8cfed5eabba566a7c9857faff15202fbde0ce33bcc2b700bcd9f38a86e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8745e9f37219741d288cb6d4a4c98c9785440124f05cf616432a3705c03526e7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c5479b8cfed5eabba566a7c9857faff15202fbde0ce33bcc2b700bcd9f38a86e.png",
  location: "Canton, MI, USA",
  minimumOrderDollars: 50,
  rating: 4.7,
  reviewCount: 149,
  isInsider: true,
  description:
    "At Nova Brands, we believe chocolate is more than a sweet—it’s an art form. Blending time-honored Swiss traditions with the rich decadence of fine Belgian chocolate, our creations are handcrafted by skilled chocolatiers who treat each piece as a miniature masterpiece.\n\nEvery ingredient is carefully chosen, every detail meticulously shaped, and every bite designed to awaken the senses. From smooth truffles to intricate pralines, our chocolates reflect the passion and precision of true artisans who pour their heart into every mold and swirl.\n\nWhether you’re gifting, celebrating, or simply indulging, Nova Brands invites you to experience chocolate made with soul—where elegance meets artistry in every delicious moment.",
  meta: {
    source: "api",
    importedAt: "2026-07-17T19:04:04.525Z",
    importedBy: "entity-db-cli",
  },
};
